<template>
    <div id="payer-add-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Master Payer List</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                    
                </div>
                <div class="modal-body">                    
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
                        </div>
                        <input type="text" class="form-control" placeholder="Search" v-model="searchString">
                    </div>
                    <div v-if="message" class="text-center text-danger mt-2"><strong>{{ message }}</strong></div>                                                              
                    <div class="mt-3">
                        <div v-if="filteredPayers.length > 0" class="list-group list-group-scroll mt-2">
                            <template v-for="payer in filteredPayers">
                                <button type="button" class="list-group-item list-group-item-action" @click="addPayer(payer.id)" :key="payer.id">
                                    <div style="line-height: 1">{{ payer.name }} <span v-if="payer.managing_carrier_name">({{ payer.managing_carrier_name }})</span></div>
                                    <div style="line-height: 1"><small>{{ address(payer) }}</small></div>
                                    <div style="line-height: 1"><small>{{ payer.fax_number | telephone }}</small></div>
                                </button>
                            </template>
                        </div>
                        <div v-else class="h3 text-muted text-center mt-2">No Payers</div> 
                    </div>                     
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="newPayer()">New</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            clientId: 0,
            searchString: '',
            payers: [],
            message: '',
        }
    },
    computed: {
        filteredPayers: function () {
            var self = this;
            return self.payers.filter(function (payer) {
                return (payer.name.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
            });
        },
    },
    methods: {
        show: function (id) {

            this.clientId = id;
            this.searchString = '';
            this.payers = [];

            axios.get('/ajax/provider/clients/' + this.clientId + '/payers/options')
                .then(response => {
                    this.payers = response.data.payers;
                    $('#payer-add-modal').modal('show');
                })
                .catch(error => {
                    console.log('error');
                });
        },
        hide: function () {
            $('#payer-add-modal').modal('hide');
        }, 
        addPayer: function (payerId) {
            axios.post('/ajax/provider/clients/' + this.clientId + '/payers', {
                payerId: payerId
            })
            .then(response => {
                this.hide();
            })
            .catch(error => {
                this.message = error.response.data.message;
            });
        },
        newPayer: function () {
            this.hide();
            window.location = '/provider/clients/' + this.clientId + '/payers/new';
        },
        address: function (payer) {
            return ((payer.address || '') + ' ' + (payer.city || '') + ' ' + (payer.state || '') + ' ' + (payer.postal_code || '')).trim();
        },              
    },
    created() {
        eventHub.$on('show-payer-add', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-payer-add');
    },   
}
</script>

<style>
    .list-group-scroll {
        max-height: 500px; 
        overflow: scroll; 
        -webkit-overflow-scrolling: touch;
    }
</style>


